import { Config } from '../config';
var Star = /** @class */ (function () {
    function Star(drawingContext) {
        this.drawingContext = drawingContext;
        this.maxStarRadius = 3;
        this.flashingFactor = 0.4;
        this.x = Math.random() * Config.canvasWidth;
        this.y = Math.random() * Config.canvasHeight;
        this.r = Math.random() * this.maxStarRadius;
        this.b = Math.trunc(Math.random() * 100) / 100;
    }
    Star.prototype.draw = function () {
        this.b += this.flashingFactor * (Math.random() - .5);
        this.drawingContext.fillStyle = "rgba(255,255,255," + this.b + ")";
        this.drawingContext.beginPath();
        this.drawingContext.arc(Math.trunc(this.x), Math.trunc(this.y), this.r, 0, Math.PI * 2);
        this.drawingContext.fill();
        this.drawingContext.closePath();
    };
    return Star;
}());
export { Star };
